export const KEYS = {
    // Common
    COMMON_EMAIL: 'common.email',
    COMMON_PASSWORD: 'common.password',
    COMMON_NAME: 'common.name',
    COMMON_BACK: 'common.back',
    COMMON_LOADING: 'common.loading',
    COMMON_BACK_TO_LOGIN: 'common.back_to_login',
    COMMON_ERROR_GENERIC: 'common.error_generic',
    COMMON_NEVER: 'common.never',
    COMMON_CANCEL: 'common.cancel',
    COMMON_SAVE: 'common.save',
    COMMON_CLOSE: 'common.close',
    COMMON_CONFIRM: 'common.confirm',
    COMMON_DELETE: 'common.delete',
    COMMON_EDIT: 'common.edit',
    COMMON_ADD: 'common.add',
    COMMON_RETRY: 'common.retry',
    COMMON_VIEW: 'common.view',
    COMMON_RESET: 'common.reset',
    COMMON_YES: 'common.yes',
    COMMON_NO: 'common.no',
    COMMON_DESCRIPTION: 'common.description',
    COMMON_PHONE: 'common.phone',
    COMMON_WEBSITE: 'common.website',
    COMMON_NOTES: 'common.notes',
    COMMON_STATUS: 'common.status',
    COMMON_DETAILS: 'common.details',
    COMMON_LABEL: 'common.label',
    COMMON_VALUE: 'common.value',
    COMMON_UNIT: 'common.unit',
    COMMON_TYPE: 'common.type',
    COMMON_SERVICE: 'common.service',
    COMMON_SUPPLIER: 'common.supplier',
    COMMON_FREQUENCY: 'common.frequency',
    COMMON_TITLE: 'common.title',
    COMMON_AMOUNT: 'common.amount',
    COMMON_CREATING: 'common.creating',
    COMMON_SAVING: 'common.saving',
    COMMON_DELETING: 'common.deleting',
    COMMON_UPDATING: 'common.updating',
    COMMON_GENERATING: 'common.generating',
    COMMON_ADDING: 'common.adding',
    COMMON_SAVE_CHANGES: 'common.save_changes',
    COMMON_CANNOT_UNDO: 'common.cannot_undo',
    COMMON_DONE: 'common.done',
    COMMON_COPY: 'common.copy',
    COMMON_COPIED: 'common.copied',
    COMMON_ERROR_MAX_CHARS: 'common.error_max_chars',
    COMMON_ERROR_INVALID_EMAIL: 'common.error_invalid_email',
    COMMON_ERROR_INVALID_URL: 'common.error_invalid_url',
    COMMON_DATE_ISSUED: 'common.date_issued',
    COMMON_DATE_DUE: 'common.date_due',
    COMMON_DATE_PAID: 'common.date_paid',
    COMMON_MARK_AS_PAID: 'common.mark_as_paid',
    COMMON_MARK_AS_READ: 'common.mark_as_read',
    COMMON_LOAD_MORE: 'common.load_more',
    COMMON_UNKNOWN_SERVICE: 'common.unknown_service',
    COMMON_CREATED_BY: 'common.created_by',
    COMMON_ACTIONS: 'common.actions',
    COMMON_OPTIONAL: 'common.optional',

    // Service types (shared across many screens/modals)
    TYPE_ELECTRICITY: 'type.electricity',
    TYPE_NATURAL_GAS: 'type.natural_gas',
    TYPE_WATER: 'type.water',
    TYPE_PHONE: 'type.phone',
    TYPE_INTERNET: 'type.internet',
    TYPE_OTHER: 'type.other',

    // Empty states
    EMPTY_SUPPLIERS_TITLE: 'empty.suppliers_title',
    EMPTY_SUPPLIERS_DESCRIPTION: 'empty.suppliers_description',
    EMPTY_SUPPLIERS_ACTION: 'empty.suppliers_action',
    EMPTY_SERVICES_TITLE: 'empty.services_title',
    EMPTY_SERVICES_DESCRIPTION: 'empty.services_description',
    EMPTY_SERVICES_ACTION: 'empty.services_action',
    EMPTY_INVOICES_TITLE: 'empty.invoices_title',
    EMPTY_INVOICES_DESCRIPTION: 'empty.invoices_description',
    EMPTY_INVOICES_ACTION: 'empty.invoices_action',
    EMPTY_READINGS_TITLE: 'empty.readings_title',
    EMPTY_READINGS_DESCRIPTION: 'empty.readings_description',
    EMPTY_READINGS_ACTION: 'empty.readings_action',
    EMPTY_CREDENTIALS_TITLE: 'empty.credentials_title',
    EMPTY_CREDENTIALS_DESCRIPTION: 'empty.credentials_description',
    EMPTY_CREDENTIALS_ACTION: 'empty.credentials_action',
    EMPTY_REMINDERS_TITLE: 'empty.reminders_title',
    EMPTY_REMINDERS_DESCRIPTION: 'empty.reminders_description',
    EMPTY_REMINDERS_ACTION: 'empty.reminders_action',
    EMPTY_SEARCH_TITLE: 'empty.search_title',
    EMPTY_SEARCH_DESCRIPTION: 'empty.search_description',
    EMPTY_SEARCH_DESCRIPTION_GENERIC: 'empty.search_description_generic',
    EMPTY_ERROR_TITLE: 'empty.error_title',
    EMPTY_ERROR_DESCRIPTION: 'empty.error_description',

    // Login screen
    LOGIN_TAGLINE: 'login.tagline',
    LOGIN_FORGOT_PASSWORD: 'login.forgot_password',
    LOGIN_SUBMIT: 'login.submit',
    LOGIN_SUBMITTING: 'login.submitting',
    LOGIN_NO_ACCOUNT: 'login.no_account',
    LOGIN_CREATE_ONE: 'login.create_one',
    LOGIN_RESET_SUCCESS: 'login.reset_success',
    LOGIN_ERROR_GENERIC: 'login.error_generic',
    LOGIN_REMEMBER_ME: 'login.remember_me',

    // Register screen
    REGISTER_TAGLINE_INVITE: 'register.tagline_invite',
    REGISTER_TAGLINE_FORM: 'register.tagline_form',
    REGISTER_INVITE_CODE: 'register.invite_code',
    REGISTER_INVITE_PLACEHOLDER: 'register.invite_placeholder',
    REGISTER_CONTINUE: 'register.continue',
    REGISTER_CONTINUING: 'register.continuing',
    REGISTER_CONFIRM_PASSWORD: 'register.confirm_password',
    REGISTER_SUBMIT: 'register.submit',
    REGISTER_SUBMITTING: 'register.submitting',
    REGISTER_ALREADY_ACCOUNT: 'register.already_account',
    REGISTER_SIGN_IN: 'register.sign_in',
    REGISTER_ERROR_INVITE_REQUIRED: 'register.error_invite_required',
    REGISTER_ERROR_PASSWORDS_MISMATCH: 'register.error_passwords_mismatch',
    REGISTER_ERROR_GENERIC: 'register.error_generic',

    // Navigation (TopBar route titles)
    NAV_DASHBOARD: 'nav.dashboard',
    NAV_SUPPLIERS: 'nav.suppliers',
    NAV_SERVICES: 'nav.services',
    NAV_INVOICES: 'nav.invoices',
    NAV_PROFILE: 'nav.profile',
    NAV_REMINDERS: 'nav.reminders',
    NAV_NOTIFICATIONS: 'nav.notifications',
    NAV_API_KEYS: 'nav.api_keys',
    NAV_SECTION_MAIN: 'nav.section_main',
    NAV_SECTION_MANAGEMENT: 'nav.section_management',
    NAV_LOGOUT: 'nav.logout',
    LAYOUT_VERIFY_EMAIL: 'layout.verify_email',
    LAYOUT_VERIFY_EMAIL_SENT: 'layout.verify_email_sent',
    LAYOUT_VERIFY_EMAIL_ALREADY: 'layout.verify_email_already',
    LAYOUT_VERIFY_EMAIL_RESEND: 'layout.verify_email_resend',
    LAYOUT_VERIFY_EMAIL_RESENDING: 'layout.verify_email_resending',

    // Forgot Password screen
    FORGOT_PASSWORD_TAGLINE: 'forgot_password.tagline',
    FORGOT_PASSWORD_DESCRIPTION: 'forgot_password.description',
    FORGOT_PASSWORD_SUBMIT: 'forgot_password.submit',
    FORGOT_PASSWORD_SUBMITTING: 'forgot_password.submitting',
    FORGOT_PASSWORD_SENT: 'forgot_password.sent',
    FORGOT_PASSWORD_CHECK_SPAM: 'forgot_password.check_spam',
    FORGOT_PASSWORD_TRY_AGAIN: 'forgot_password.try_again',

    // Reset Password screen
    RESET_PASSWORD_TAGLINE: 'reset_password.tagline',
    RESET_PASSWORD_NEW_PASSWORD: 'reset_password.new_password',
    RESET_PASSWORD_CONFIRM_PASSWORD: 'reset_password.confirm_password',
    RESET_PASSWORD_SUBMIT: 'reset_password.submit',
    RESET_PASSWORD_SUBMITTING: 'reset_password.submitting',
    RESET_PASSWORD_ERROR_PASSWORDS_MISMATCH: 'reset_password.error_passwords_mismatch',

    // Home / Dashboard screen
    HOME_TITLE: 'home.title',
    HOME_SUBTITLE: 'home.subtitle',
    HOME_STAT_TOTAL_SERVICES: 'home.stat_total_services',
    HOME_STAT_MONTHLY_SPEND: 'home.stat_monthly_spend',
    HOME_STAT_SUPPLIERS: 'home.stat_suppliers',
    HOME_STAT_SERVICE_TYPES: 'home.stat_service_types',
    HOME_UPCOMING_DUE: 'home.upcoming_due',
    HOME_OUTSTANDING_BY_CATEGORY: 'home.outstanding_by_category',
    HOME_NO_UPCOMING_INVOICES: 'home.no_upcoming_invoices',
    HOME_NO_OUTSTANDING_INVOICES: 'home.no_outstanding_invoices',
    HOME_ERROR_LOAD: 'home.error_load',

    // Suppliers screen
    SUPPLIERS_TITLE: 'suppliers.title',
    SUPPLIERS_SUBTITLE: 'suppliers.subtitle',
    SUPPLIERS_ADD: 'suppliers.add',
    SUPPLIERS_ERROR_LOAD: 'suppliers.error_load',
    SUPPLIERS_NOT_FOUND: 'suppliers.not_found',
    SUPPLIERS_BACK: 'suppliers.back',

    // Services screen
    SERVICES_TITLE: 'services.title',
    SERVICES_SUBTITLE: 'services.subtitle',
    SERVICES_ERROR_LOAD: 'services.error_load',
    SERVICES_NOT_FOUND: 'services.not_found',
    SERVICES_BACK: 'services.back',
    SERVICES_ADD: 'services.add',

    // Service Detail screen
    SERVICE_DETAIL_EDIT: 'service_detail.edit',
    SERVICE_DETAIL_DETAILS: 'service_detail.details',
    SERVICE_DETAIL_TYPE: 'service_detail.type',
    SERVICE_DETAIL_SUPPLIER: 'service_detail.supplier',
    SERVICE_DETAIL_DESCRIPTION: 'service_detail.description',
    SERVICE_DETAIL_NAV_READINGS: 'service_detail.nav_readings',
    SERVICE_DETAIL_NAV_READINGS_SUB: 'service_detail.nav_readings_sub',
    SERVICE_DETAIL_NAV_INVOICES: 'service_detail.nav_invoices',
    SERVICE_DETAIL_NAV_INVOICES_SUB: 'service_detail.nav_invoices_sub',
    SERVICE_DETAIL_NAV_READING_TEMPLATES: 'service_detail.nav_reading_templates',
    SERVICE_DETAIL_NAV_READING_TEMPLATES_SUB: 'service_detail.nav_reading_templates_sub',
    SERVICE_DETAIL_NAV_INVOICE_TEMPLATES: 'service_detail.nav_invoice_templates',
    SERVICE_DETAIL_NAV_INVOICE_TEMPLATES_SUB: 'service_detail.nav_invoice_templates_sub',
    SERVICE_DETAIL_NAV_ACTIONS: 'service_detail.nav_actions',
    SERVICE_DETAIL_NAV_ACTIONS_SUB: 'service_detail.nav_actions_sub',
    SERVICE_DETAIL_INVOICE_HISTORY: 'service_detail.invoice_history',

    // Service Readings sub-screen
    SERVICE_READINGS_TITLE: 'service_readings.title',
    SERVICE_READINGS_ADD: 'service_readings.add',
    SERVICE_READINGS_ERROR_LOAD: 'service_readings.error_load',
    SERVICE_READINGS_COL_VALUE: 'service_readings.col_value',
    SERVICE_READINGS_COL_UNIT: 'service_readings.col_unit',
    SERVICE_READINGS_COL_READ_DATE: 'service_readings.col_read_date',
    SERVICE_READINGS_COL_NOTES: 'service_readings.col_notes',

    // Service Invoices sub-screen
    SERVICE_INVOICES_TITLE: 'service_invoices.title',
    SERVICE_INVOICES_ADD: 'service_invoices.add',
    SERVICE_INVOICES_ERROR_LOAD: 'service_invoices.error_load',

    // Service Invoice Templates sub-screen
    SERVICE_INVOICE_TEMPLATES_TITLE: 'service_invoice_templates.title',
    SERVICE_INVOICE_TEMPLATES_ADD: 'service_invoice_templates.add',
    SERVICE_INVOICE_TEMPLATES_ERROR_LOAD: 'service_invoice_templates.error_load',
    SERVICE_INVOICE_TEMPLATES_COL_LABEL: 'service_invoice_templates.col_label',
    SERVICE_INVOICE_TEMPLATES_COL_NAME: 'service_invoice_templates.col_name',
    SERVICE_INVOICE_TEMPLATES_COL_AMOUNT: 'service_invoice_templates.col_amount',
    SERVICE_INVOICE_TEMPLATES_COL_ISSUE_DATE: 'service_invoice_templates.col_issue_date',
    SERVICE_INVOICE_TEMPLATES_COL_DUE_DATE: 'service_invoice_templates.col_due_date',
    SERVICE_INVOICE_TEMPLATES_EMPTY: 'service_invoice_templates.empty',

    // Service Reading Templates sub-screen
    SERVICE_READING_TEMPLATES_TITLE: 'service_reading_templates.title',
    SERVICE_READING_TEMPLATES_ADD: 'service_reading_templates.add',
    SERVICE_READING_TEMPLATES_ERROR_LOAD: 'service_reading_templates.error_load',
    SERVICE_READING_TEMPLATES_COL_LABEL: 'service_reading_templates.col_label',
    SERVICE_READING_TEMPLATES_EMPTY: 'service_reading_templates.empty',

    // Scheduled Actions sub-screen
    SERVICE_ACTIONS_TITLE: 'service_actions.title',
    SERVICE_ACTIONS_ADD: 'service_actions.add',
    SERVICE_ACTIONS_ERROR_LOAD: 'service_actions.error_load',
    SERVICE_ACTIONS_COL_TYPE: 'service_actions.col_type',
    SERVICE_ACTIONS_COL_FREQUENCY: 'service_actions.col_frequency',
    SERVICE_ACTIONS_COL_NEXT_RUN: 'service_actions.col_next_run',
    SERVICE_ACTIONS_COL_LAST_RUN: 'service_actions.col_last_run',
    SERVICE_ACTIONS_COL_ACTIVE: 'service_actions.col_active',
    SERVICE_ACTIONS_EMPTY: 'service_actions.empty',
    SERVICE_ACTIONS_TYPE_CREATE_INVOICE: 'service_actions.type_create_invoice',
    SERVICE_ACTIONS_TYPE_CREATE_READING: 'service_actions.type_create_reading',
    SERVICE_ACTIONS_FREQ_ONCE: 'service_actions.freq_once',
    SERVICE_ACTIONS_FREQ_DAILY: 'service_actions.freq_daily',
    SERVICE_ACTIONS_FREQ_WEEKLY: 'service_actions.freq_weekly',
    SERVICE_ACTIONS_FREQ_MONTHLY: 'service_actions.freq_monthly',
    SERVICE_ACTIONS_FREQ_YEARLY: 'service_actions.freq_yearly',

    // Invoices screen
    INVOICES_TITLE: 'invoices.title',
    INVOICES_SUBTITLE: 'invoices.subtitle',
    INVOICES_ADD: 'invoices.add',
    INVOICES_ERROR_LOAD: 'invoices.error_load',
    INVOICES_COL_NAME: 'invoices.col_name',
    INVOICES_COL_SERVICE: 'invoices.col_service',
    INVOICES_COL_ISSUED: 'invoices.col_issued',
    INVOICES_COL_DUE: 'invoices.col_due',
    INVOICES_COL_AMOUNT: 'invoices.col_amount',
    INVOICES_COL_STATUS: 'invoices.col_status',
    INVOICES_FILTER_ALL: 'invoices.filter_all',
    INVOICES_FILTER_UNPAID: 'invoices.filter_unpaid',
    INVOICES_FILTER_PAID: 'invoices.filter_paid',
    INVOICES_FILTER_OVERDUE: 'invoices.filter_overdue',
    INVOICES_RESET_FILTERS: 'invoices.reset_filters',
    INVOICES_STATUS_PAID: 'invoices.status_paid',
    INVOICES_STATUS_PENDING: 'invoices.status_pending',
    INVOICES_STATUS_OVERDUE: 'invoices.status_overdue',
    INVOICES_STATUS_UPCOMING: 'invoices.status_upcoming',
    INVOICES_LOAD_MORE: 'invoices.load_more',
    INVOICES_LOADING_MORE: 'invoices.loading_more',
    CREATED_BY_USER: 'created_by.user',
    CREATED_BY_AUTOMATION: 'created_by.automation',
    CREATED_BY_SCHEDULE: 'created_by.schedule',
    CREATED_BY_UNKNOWN: 'created_by.unknown',

    // Reminders screen
    REMINDERS_TITLE: 'reminders.title',
    REMINDERS_SUBTITLE: 'reminders.subtitle',
    REMINDERS_ADD: 'reminders.add',
    REMINDERS_ERROR_LOAD: 'reminders.error_load',
    REMINDERS_COL_TITLE: 'reminders.col_title',
    REMINDERS_COL_DUE_DATE: 'reminders.col_due_date',
    REMINDERS_COL_FREQUENCY: 'reminders.col_frequency',
    REMINDERS_COL_STATUS: 'reminders.col_status',
    REMINDERS_STATUS_OVERDUE: 'reminders.status_overdue',
    REMINDERS_STATUS_ACTIVE: 'reminders.status_active',
    REMINDERS_STATUS_INACTIVE: 'reminders.status_inactive',
    REMINDERS_FREQ_QUARTERLY: 'reminders.freq_quarterly',

    // Profile screen
    PROFILE_EMAIL: 'profile.email',
    PROFILE_MEMBER_SINCE: 'profile.member_since',
    PROFILE_EDIT: 'profile.edit',
    PROFILE_DELETE: 'profile.delete',
    PROFILE_INTEGRATIONS: 'profile.integrations',
    PROFILE_API_KEYS_LABEL: 'profile.api_keys_label',
    PROFILE_API_KEYS_DESCRIPTION: 'profile.api_keys_description',
    PROFILE_INVITE_CODES_LABEL: 'profile.invite_codes_label',
    PROFILE_INVITE_CODES_DESCRIPTION: 'profile.invite_codes_description',
    PROFILE_ERROR_LOAD: 'profile.error_load',
    PROFILE_UPDATE_SUCCESS: 'profile.update_success',
    PROFILE_PREFERENCES: 'profile.preferences',
    PROFILE_CURRENCY: 'profile.currency',

    // API Keys screen
    API_KEYS_TITLE: 'api_keys.title',
    API_KEYS_SUBTITLE: 'api_keys.subtitle',
    API_KEYS_ADD: 'api_keys.add',
    API_KEYS_ERROR_LOAD: 'api_keys.error_load',
    API_KEYS_COL_NAME: 'api_keys.col_name',
    API_KEYS_COL_ABILITIES: 'api_keys.col_abilities',
    API_KEYS_COL_LAST_USED: 'api_keys.col_last_used',
    API_KEYS_COL_EXPIRES: 'api_keys.col_expires',
    API_KEYS_FULL_ACCESS: 'api_keys.full_access',
    API_KEYS_SCOPES_SINGULAR: 'api_keys.scopes_singular',
    API_KEYS_SCOPES_PLURAL: 'api_keys.scopes_plural',
    API_KEYS_EMPTY_TITLE: 'api_keys.empty_title',
    API_KEYS_EMPTY_DESCRIPTION: 'api_keys.empty_description',

    // Invite Codes screen
    INVITE_CODES_TITLE: 'invite_codes.title',
    INVITE_CODES_SUBTITLE: 'invite_codes.subtitle',
    INVITE_CODES_GENERATE: 'invite_codes.generate',
    INVITE_CODES_GENERATING: 'invite_codes.generating',
    INVITE_CODES_ERROR_LOAD: 'invite_codes.error_load',
    INVITE_CODES_COL_CODE: 'invite_codes.col_code',
    INVITE_CODES_COL_STATUS: 'invite_codes.col_status',
    INVITE_CODES_COL_USED: 'invite_codes.col_used',
    INVITE_CODES_COL_CREATED: 'invite_codes.col_created',
    INVITE_CODES_STATUS_USED: 'invite_codes.status_used',
    INVITE_CODES_STATUS_UNUSED: 'invite_codes.status_unused',
    INVITE_CODES_EMPTY_TITLE: 'invite_codes.empty_title',
    INVITE_CODES_EMPTY_DESCRIPTION: 'invite_codes.empty_description',

    // Notifications screen
    NOTIFICATIONS_TITLE: 'notifications.title',
    NOTIFICATIONS_SUBTITLE: 'notifications.subtitle',
    NOTIFICATIONS_MARK_ALL_READ: 'notifications.mark_all_read',
    NOTIFICATIONS_MARK_READ: 'notifications.mark_read',
    NOTIFICATIONS_EMPTY: 'notifications.empty',
    NOTIFICATIONS_PUSH_TITLE: 'notifications.push_title',
    NOTIFICATIONS_PUSH_DESCRIPTION: 'notifications.push_description',
    NOTIFICATIONS_PUSH_ENABLE: 'notifications.push_enable',
    NOTIFICATIONS_PUSH_DISABLE: 'notifications.push_disable',
    NOTIFICATIONS_PUSH_NOT_SUPPORTED: 'notifications.push_not_supported',
    NOTIFICATIONS_PUSH_PERMISSION_DENIED: 'notifications.push_permission_denied',
    NOTIFICATIONS_PUSH_ERROR: 'notifications.push_error',
    NOTIFICATIONS_ERROR_LOAD: 'notifications.error_load',
    NOTIFICATIONS_CLEAR_READ: 'notifications.clear_read',

    // Supplier modals
    SUPPLIER_ADD_TITLE: 'supplier_modal.add_title',
    SUPPLIER_ADD_SUBTITLE: 'supplier_modal.add_subtitle',
    SUPPLIER_ADD_SUBMIT: 'supplier_modal.add_submit',
    SUPPLIER_ADD_SUBMITTING: 'supplier_modal.add_submitting',
    SUPPLIER_ADD_ERROR: 'supplier_modal.add_error',
    SUPPLIER_EDIT_TITLE: 'supplier_modal.edit_title',
    SUPPLIER_EDIT_SUBTITLE: 'supplier_modal.edit_subtitle',
    SUPPLIER_EDIT_SUBMIT: 'supplier_modal.edit_submit',
    SUPPLIER_EDIT_SUBMITTING: 'supplier_modal.edit_submitting',
    SUPPLIER_EDIT_ERROR: 'supplier_modal.edit_error',
    SUPPLIER_DELETE_TITLE: 'supplier_modal.delete_title',
    SUPPLIER_DELETE_SUBTITLE: 'supplier_modal.delete_subtitle',
    SUPPLIER_DELETE_BODY: 'supplier_modal.delete_body',
    SUPPLIER_DELETE_SUBMITTING: 'supplier_modal.delete_submitting',
    SUPPLIER_DELETE_ERROR: 'supplier_modal.delete_error',

    // Credential modals
    CREDENTIAL_ADD_TITLE: 'credential_modal.add_title',
    CREDENTIAL_ADD_SUBTITLE: 'credential_modal.add_subtitle',
    CREDENTIAL_ADD_SUBMIT: 'credential_modal.add_submit',
    CREDENTIAL_ADD_SUBMITTING: 'credential_modal.add_submitting',
    CREDENTIAL_ADD_ERROR: 'credential_modal.add_error',
    CREDENTIAL_EDIT_TITLE: 'credential_modal.edit_title',
    CREDENTIAL_EDIT_SUBTITLE: 'credential_modal.edit_subtitle',
    CREDENTIAL_EDIT_SUBMIT: 'credential_modal.edit_submit',
    CREDENTIAL_EDIT_SUBMITTING: 'credential_modal.edit_submitting',
    CREDENTIAL_EDIT_ERROR: 'credential_modal.edit_error',
    CREDENTIAL_DELETE_TITLE: 'credential_modal.delete_title',
    CREDENTIAL_DELETE_SUBTITLE: 'credential_modal.delete_subtitle',
    CREDENTIAL_DELETE_BODY: 'credential_modal.delete_body',
    CREDENTIAL_DELETE_SUBMITTING: 'credential_modal.delete_submitting',
    CREDENTIAL_DELETE_ERROR: 'credential_modal.delete_error',
    CREDENTIAL_VIEW_TITLE: 'credential_modal.view_title',
    CREDENTIAL_VIEW_USERNAME: 'credential_modal.view_username',
    CREDENTIAL_VIEW_PASSWORD: 'credential_modal.view_password',
    CREDENTIAL_VIEW_COPY: 'credential_modal.view_copy',
    CREDENTIAL_VIEW_COPIED: 'credential_modal.view_copied',
    CREDENTIAL_VIEW_AUTO_CLOSE: 'credential_modal.view_auto_close',
    CREDENTIAL_VIEW_NOTES: 'credential_modal.view_notes',
    CREDENTIAL_WARNING_TITLE: 'credential_modal.warning_title',
    CREDENTIAL_WARNING_BODY: 'credential_modal.warning_body',
    CREDENTIAL_WARNING_CONFIRM: 'credential_modal.warning_confirm',

    // Service modals
    SERVICE_ADD_TITLE: 'service_modal.add_title',
    SERVICE_ADD_SUBTITLE: 'service_modal.add_subtitle',
    SERVICE_ADD_SUBMIT: 'service_modal.add_submit',
    SERVICE_ADD_SUBMITTING: 'service_modal.add_submitting',
    SERVICE_ADD_ERROR: 'service_modal.add_error',
    SERVICE_ADD_TYPE_REQUIRED: 'service_modal.add_type_required',
    SERVICE_EDIT_TITLE: 'service_modal.edit_title',
    SERVICE_EDIT_SUBTITLE: 'service_modal.edit_subtitle',
    SERVICE_EDIT_SUBMIT: 'service_modal.edit_submit',
    SERVICE_EDIT_SUBMITTING: 'service_modal.edit_submitting',
    SERVICE_EDIT_ERROR: 'service_modal.edit_error',
    SERVICE_DELETE_TITLE: 'service_modal.delete_title',
    SERVICE_DELETE_SUBTITLE: 'service_modal.delete_subtitle',
    SERVICE_DELETE_BODY: 'service_modal.delete_body',
    SERVICE_DELETE_SUBMITTING: 'service_modal.delete_submitting',
    SERVICE_DELETE_ERROR: 'service_modal.delete_error',

    // Reading modals
    READING_ADD_TITLE: 'reading_modal.add_title',
    READING_ADD_SUBMIT: 'reading_modal.add_submit',
    READING_ADD_SUBMITTING: 'reading_modal.add_submitting',
    READING_ADD_ERROR: 'reading_modal.add_error',
    READING_EDIT_TITLE: 'reading_modal.edit_title',
    READING_EDIT_SUBMIT: 'reading_modal.edit_submit',
    READING_EDIT_SUBMITTING: 'reading_modal.edit_submitting',
    READING_EDIT_ERROR: 'reading_modal.edit_error',
    READING_DELETE_TITLE: 'reading_modal.delete_title',
    READING_DELETE_SUBTITLE: 'reading_modal.delete_subtitle',
    READING_DELETE_BODY: 'reading_modal.delete_body',
    READING_DELETE_SUBMITTING: 'reading_modal.delete_submitting',
    READING_DELETE_ERROR: 'reading_modal.delete_error',
    READING_VIEW_TITLE: 'reading_modal.view_title',
    READING_VIEW_READ_DATE: 'reading_modal.view_read_date',
    READING_FIELD_FILE: 'reading_modal.field_file',
    READING_FIELD_VALUE_REQUIRED: 'reading_modal.field_value_required',
    READING_FIELD_DATE_REQUIRED: 'reading_modal.field_date_required',

    // Reading Template modals
    READING_TEMPLATE_ADD_TITLE: 'reading_template_modal.add_title',
    READING_TEMPLATE_ADD_SUBMIT: 'reading_template_modal.add_submit',
    READING_TEMPLATE_ADD_SUBMITTING: 'reading_template_modal.add_submitting',
    READING_TEMPLATE_ADD_ERROR: 'reading_template_modal.add_error',
    READING_TEMPLATE_EDIT_TITLE: 'reading_template_modal.edit_title',
    READING_TEMPLATE_EDIT_SUBMIT: 'reading_template_modal.edit_submit',
    READING_TEMPLATE_EDIT_SUBMITTING: 'reading_template_modal.edit_submitting',
    READING_TEMPLATE_EDIT_ERROR: 'reading_template_modal.edit_error',
    READING_TEMPLATE_DELETE_TITLE: 'reading_template_modal.delete_title',
    READING_TEMPLATE_DELETE_SUBTITLE: 'reading_template_modal.delete_subtitle',
    READING_TEMPLATE_DELETE_SUBMITTING: 'reading_template_modal.delete_submitting',
    READING_TEMPLATE_DELETE_ERROR: 'reading_template_modal.delete_error',
    READING_TEMPLATE_FIELD_LABEL_REQUIRED: 'reading_template_modal.field_label_required',

    // Reminder modals
    REMINDER_ADD_TITLE: 'reminder_modal.add_title',
    REMINDER_ADD_SUBMIT: 'reminder_modal.add_submit',
    REMINDER_ADD_SUBMITTING: 'reminder_modal.add_submitting',
    REMINDER_ADD_ERROR: 'reminder_modal.add_error',
    REMINDER_EDIT_TITLE: 'reminder_modal.edit_title',
    REMINDER_EDIT_SUBMIT: 'reminder_modal.edit_submit',
    REMINDER_EDIT_SUBMITTING: 'reminder_modal.edit_submitting',
    REMINDER_EDIT_ERROR: 'reminder_modal.edit_error',
    REMINDER_DELETE_TITLE: 'reminder_modal.delete_title',
    REMINDER_DELETE_SUBTITLE: 'reminder_modal.delete_subtitle',
    REMINDER_DELETE_SUBMITTING: 'reminder_modal.delete_submitting',
    REMINDER_DELETE_ERROR: 'reminder_modal.delete_error',
    REMINDER_VIEW_SUBTITLE: 'reminder_modal.view_subtitle',
    REMINDER_VIEW_ADVANCE: 'reminder_modal.view_advance',
    REMINDER_VIEW_ADVANCING: 'reminder_modal.view_advancing',
    REMINDER_VIEW_ADVANCE_ERROR: 'reminder_modal.view_advance_error',
    REMINDER_FREQ_ONCE: 'reminder_modal.freq_once',
    REMINDER_FREQ_DAILY: 'reminder_modal.freq_daily',
    REMINDER_FREQ_WEEKLY: 'reminder_modal.freq_weekly',
    REMINDER_FREQ_MONTHLY: 'reminder_modal.freq_monthly',
    REMINDER_FREQ_QUARTERLY: 'reminder_modal.freq_quarterly',
    REMINDER_FREQ_YEARLY: 'reminder_modal.freq_yearly',
    REMINDER_FIELD_TITLE_REQUIRED: 'reminder_modal.field_title_required',
    REMINDER_FIELD_DATE_REQUIRED: 'reminder_modal.field_date_required',
    REMINDER_FIELD_FREQ_REQUIRED: 'reminder_modal.field_freq_required',
    REMINDER_FIELD_IS_ACTIVE: 'reminder_modal.field_is_active',

    // Invoice modals
    INVOICE_ADD_TITLE: 'invoice_modal.add_title',
    INVOICE_ADD_SUBTITLE: 'invoice_modal.add_subtitle',
    INVOICE_ADD_SUBMIT: 'invoice_modal.add_submit',
    INVOICE_ADD_SUBMITTING: 'invoice_modal.add_submitting',
    INVOICE_ADD_ERROR: 'invoice_modal.add_error',
    INVOICE_EDIT_TITLE: 'invoice_modal.edit_title',
    INVOICE_EDIT_SUBMIT: 'invoice_modal.edit_submit',
    INVOICE_EDIT_SUBMITTING: 'invoice_modal.edit_submitting',
    INVOICE_EDIT_ERROR: 'invoice_modal.edit_error',
    INVOICE_DELETE_TITLE: 'invoice_modal.delete_title',
    INVOICE_DELETE_SUBTITLE: 'invoice_modal.delete_subtitle',
    INVOICE_DELETE_SUBMITTING: 'invoice_modal.delete_submitting',
    INVOICE_DELETE_ERROR: 'invoice_modal.delete_error',
    INVOICE_VIEW_TITLE: 'invoice_modal.view_title',
    INVOICE_FIELD_SERVICE_REQUIRED: 'invoice_modal.field_service_required',
    INVOICE_FIELD_LOADING_SERVICES: 'invoice_modal.field_loading_services',
    INVOICE_FIELD_SELECT_SERVICE: 'invoice_modal.field_select_service',
    INVOICE_AMOUNT_ERROR: 'invoice_modal.amount_error',
    INVOICE_DUE_DATE_ERROR: 'invoice_modal.due_date_error',
    INVOICE_PAID_DATE_ERROR: 'invoice_modal.paid_date_error',

    // Invoice Template modals
    INVOICE_TEMPLATE_ADD_TITLE: 'invoice_template_modal.add_title',
    INVOICE_TEMPLATE_ADD_SUBTITLE: 'invoice_template_modal.add_subtitle',
    INVOICE_TEMPLATE_ADD_SUBMIT: 'invoice_template_modal.add_submit',
    INVOICE_TEMPLATE_ADD_SUBMITTING: 'invoice_template_modal.add_submitting',
    INVOICE_TEMPLATE_ADD_ERROR: 'invoice_template_modal.add_error',
    INVOICE_TEMPLATE_EDIT_TITLE: 'invoice_template_modal.edit_title',
    INVOICE_TEMPLATE_EDIT_SUBTITLE: 'invoice_template_modal.edit_subtitle',
    INVOICE_TEMPLATE_EDIT_SUBMIT: 'invoice_template_modal.edit_submit',
    INVOICE_TEMPLATE_EDIT_SUBMITTING: 'invoice_template_modal.edit_submitting',
    INVOICE_TEMPLATE_EDIT_ERROR: 'invoice_template_modal.edit_error',
    INVOICE_TEMPLATE_DELETE_TITLE: 'invoice_template_modal.delete_title',
    INVOICE_TEMPLATE_DELETE_SUBTITLE: 'invoice_template_modal.delete_subtitle',
    INVOICE_TEMPLATE_DELETE_SUBMITTING: 'invoice_template_modal.delete_submitting',
    INVOICE_TEMPLATE_DELETE_ERROR: 'invoice_template_modal.delete_error',
    INVOICE_TEMPLATE_FIELD_LABEL_REQUIRED: 'invoice_template_modal.field_label_required',

    // Scheduled Action modals
    ACTION_ADD_TITLE: 'action_modal.add_title',
    ACTION_ADD_SUBTITLE: 'action_modal.add_subtitle',
    ACTION_ADD_SUBMIT: 'action_modal.add_submit',
    ACTION_ADD_SUBMITTING: 'action_modal.add_submitting',
    ACTION_ADD_ERROR: 'action_modal.add_error',
    ACTION_EDIT_TITLE: 'action_modal.edit_title',
    ACTION_EDIT_SUBTITLE: 'action_modal.edit_subtitle',
    ACTION_EDIT_SUBMIT: 'action_modal.edit_submit',
    ACTION_EDIT_SUBMITTING: 'action_modal.edit_submitting',
    ACTION_EDIT_ERROR: 'action_modal.edit_error',
    ACTION_DELETE_TITLE: 'action_modal.delete_title',
    ACTION_DELETE_SUBTITLE: 'action_modal.delete_subtitle',
    ACTION_DELETE_SUBMITTING: 'action_modal.delete_submitting',
    ACTION_DELETE_ERROR: 'action_modal.delete_error',
    ACTION_RUNS_TITLE: 'action_modal.runs_title',
    ACTION_RUNS_SUBTITLE: 'action_modal.runs_subtitle',
    ACTION_FIELD_TYPE: 'action_modal.field_type',
    ACTION_FIELD_TYPE_REQUIRED: 'action_modal.field_type_required',
    ACTION_FIELD_START_DATE: 'action_modal.field_start_date',
    ACTION_FIELD_FREQUENCY: 'action_modal.field_frequency',
    ACTION_FIELD_FREQUENCY_REQUIRED: 'action_modal.field_frequency_required',
    ACTION_FIELD_NEXT_RUN_REQUIRED: 'action_modal.field_next_run_required',
    ACTION_FIELD_INVOICE_TEMPLATE_REQUIRED: 'action_modal.field_invoice_template_required',
    ACTION_FIELD_READING_TEMPLATE_REQUIRED: 'action_modal.field_reading_template_required',
    ACTION_LOADING_TEMPLATES: 'action_modal.loading_templates',
    ACTION_SELECT_TEMPLATE: 'action_modal.select_template',
    ACTION_FIELD_IS_ACTIVE: 'action_modal.field_is_active',
    ACTION_RUNS_RAN_AT: 'action_modal.runs_ran_at',
    ACTION_RUNS_STATUS: 'action_modal.runs_status',
    ACTION_RUNS_RESULT: 'action_modal.runs_result',
    ACTION_RUNS_ERROR: 'action_modal.runs_error',
    ACTION_RUNS_SUCCESS: 'action_modal.runs_success',
    ACTION_RUNS_FAILED: 'action_modal.runs_failed',
    ACTION_RUNS_EMPTY: 'action_modal.runs_empty',

    // Profile modals
    EDIT_PROFILE_TITLE: 'profile_modal.edit_title',
    EDIT_PROFILE_SUBTITLE: 'profile_modal.edit_subtitle',
    EDIT_PROFILE_SUBMIT: 'profile_modal.edit_submit',
    EDIT_PROFILE_SUBMITTING: 'profile_modal.edit_submitting',
    EDIT_PROFILE_ERROR: 'profile_modal.edit_error',
    DELETE_ACCOUNT_TITLE: 'profile_modal.delete_title',
    DELETE_ACCOUNT_SUBTITLE: 'profile_modal.delete_subtitle',
    DELETE_ACCOUNT_BODY: 'profile_modal.delete_body',
    DELETE_ACCOUNT_PASSWORD_LABEL: 'profile_modal.delete_password_label',
    DELETE_ACCOUNT_SUBMIT: 'profile_modal.delete_submit',
    DELETE_ACCOUNT_SUBMITTING: 'profile_modal.delete_submitting',
    DELETE_ACCOUNT_ERROR: 'profile_modal.delete_error',
    EDIT_PROFILE_NAME_REQUIRED: 'profile_modal.edit_name_required',
    DELETE_ACCOUNT_PASSWORD_REQUIRED: 'profile_modal.delete_password_required',
    DELETE_ACCOUNT_WARNING_TITLE: 'profile_modal.delete_warning_title',

    // API Key modals
    API_KEY_ADD_TITLE: 'api_key_modal.add_title',
    API_KEY_ADD_SUBTITLE: 'api_key_modal.add_subtitle',
    API_KEY_ADD_SUBMIT: 'api_key_modal.add_submit',
    API_KEY_ADD_SUBMITTING: 'api_key_modal.add_submitting',
    API_KEY_ADD_ERROR: 'api_key_modal.add_error',
    API_KEY_EDIT_TITLE: 'api_key_modal.edit_title',
    API_KEY_EDIT_SUBTITLE: 'api_key_modal.edit_subtitle',
    API_KEY_EDIT_SUBMIT: 'api_key_modal.edit_submit',
    API_KEY_EDIT_SUBMITTING: 'api_key_modal.edit_submitting',
    API_KEY_EDIT_ERROR: 'api_key_modal.edit_error',
    API_KEY_DELETE_TITLE: 'api_key_modal.delete_title',
    API_KEY_DELETE_SUBTITLE: 'api_key_modal.delete_subtitle',
    API_KEY_DELETE_SUBMITTING: 'api_key_modal.delete_submitting',
    API_KEY_DELETE_ERROR: 'api_key_modal.delete_error',
    API_KEY_FIELD_EXPIRY: 'api_key_modal.field_expiry',
    API_KEY_FIELD_EXPIRY_HINT: 'api_key_modal.field_expiry_hint',
    API_KEY_FIELD_ABILITIES: 'api_key_modal.field_abilities',
    API_KEY_FULL_ACCESS_LABEL: 'api_key_modal.full_access_label',
    API_KEY_FULL_ACCESS_DESC: 'api_key_modal.full_access_desc',
    API_KEY_ABILITIES_REQUIRED: 'api_key_modal.abilities_required',
    API_KEY_LOADING_ABILITIES: 'api_key_modal.loading_abilities',
    API_KEY_CREATED_TITLE: 'api_key_modal.created_title',
    API_KEY_CREATED_BODY: 'api_key_modal.created_body',
    API_KEY_CREATED_HINT: 'api_key_modal.created_hint',
    API_KEY_REGEN_WARNING: 'api_key_modal.regen_warning',
    API_KEY_NAME_REQUIRED: 'api_key_modal.name_required',
    API_KEY_FIELD_EXPIRY_OPTIONAL: 'api_key_modal.field_expiry_optional',
    API_KEY_FIELD_EXPIRY_REMOVE_HINT: 'api_key_modal.field_expiry_remove_hint',
    API_KEY_CREATED_TOKEN_LABEL: 'api_key_modal.created_token_label',
    API_KEY_DELETE_BODY: 'api_key_modal.delete_body',

    // Invite Code modals
    INVITE_CODE_DELETE_TITLE: 'invite_code_modal.delete_title',
    INVITE_CODE_DELETE_SUBTITLE: 'invite_code_modal.delete_subtitle',
    INVITE_CODE_DELETE_BODY: 'invite_code_modal.delete_body',
    INVITE_CODE_DELETE_BODY_USED: 'invite_code_modal.delete_body_used',
    INVITE_CODE_DELETE_SUBMITTING: 'invite_code_modal.delete_submitting',
    INVITE_CODE_DELETE_ERROR: 'invite_code_modal.delete_error',
    INVITE_CODE_CREATED_TITLE: 'invite_code_modal.created_title',
    INVITE_CODE_CREATED_BODY: 'invite_code_modal.created_body',
    INVITE_CODE_DELETE_BODY_UNUSED: 'invite_code_modal.delete_body_unused',
    INVITE_CODE_CREATED_LABEL: 'invite_code_modal.created_label',
};
